const PSState = require('PSState');

export const MenuElements = {
    History: 'History',
    Audio: 'Audio',
    Home: 'Home',
    Paytable: 'Paytable',
    GameRules: 'GameRules',
    Clock: 'Clock',
    Autoplay: 'Autoplay',
    SessionTime: 'SessionTime',
    GameTitle: 'GameTitle',
    FastPlay: 'FastPlay',
    Balance: 'Balance',
    Audio: 'Audio',
    Home: 'Home',
    Deposit: 'Deposit',
    NoFunds: 'Dialogs.NoFunds',
    NetPosition: 'NetPosition',
    BuyFeature: 'BuyFeature',
};

export const UIComponentModes = {
    BASIC: 'BASIC',
    ADVANCED: 'ADVANCED'
};

export const UIComponentImplementationTypes = {
    BUILTIN: 'BUILTIN',
    PROVIDED: 'PROVIDED'
};

const getSlotUI = () => {
    if (window.PSGames && window.PSGames.CommonAPI) {
        return window.PSGames.CommonAPI.SlotUI;
    }
    return null;
};

const getEmptyUIElementData = () => {
    return {
        emptyData: true,
        enabled: true,
        mode: UIComponentModes.BASIC,
        implementationType: UIComponentImplementationTypes.BUILTIN
    }
}

export const getMenuElement = (elementId) => {
    const slotUI = getSlotUI();
    if (slotUI) {
        const uiElement = slotUI.getMenuElements()[elementId];
        if (uiElement) {
            return uiElement;
        } else {
            return getEmptyUIElementData();
        }
    }
    return null;
};

export const isSoundButtonEnabled = () => getMenuElement(MenuElements.Audio) && getMenuElement(MenuElements.Audio).enabled;

export const isReplayMode = () => {
    const slotUI = getSlotUI();
    if (slotUI && slotUI.isReplayMode) {
        return slotUI.isReplayMode();
    }
    return false;
}

export const isRewatchMode = () => {
    const slotUI = getSlotUI();
    if (slotUI && slotUI.isCoinsOnly) {
        return slotUI.isCoinsOnly();
    }
    return false;
}


export const isWinRestore = () => {
    const slotUI = getSlotUI();
    if (slotUI && slotUI.isWinRestore) {
        return slotUI.isWinRestore();
    }
    return false;
}

export const isFeatureLocked = () => {
    return isWinRestore() || isReplayMode();
}

export const isGoldenBetEnabled = () => {
    const slotUI = getSlotUI();
    if (slotUI && slotUI.isGoldenBetEnabled) {
        return slotUI.isGoldenBetEnabled();
    }
    return true;
}


export const getPreloaderInfo = () => {
    const slotUI = getSlotUI();
    if (slotUI) {
        return slotUI.getPreloaderInfo();
    }
    return null;
};

export const getTime = () => {
    const slotUI = getSlotUI();
    if (slotUI) {
        return slotUI.getTime();
    }
    return null;
};

export const registerComplianceBarDisplayedListener = (()=> {
    const slotUI = getSlotUI();

    // testing
    // setTimeout(onComplianceBarDisplayDataReceived, 8000, 80);

    if (!slotUI || !slotUI.onComplianceBarDisplayed) {
        return;
    }
    slotUI.onComplianceBarDisplayed(onComplianceBarDisplayDataReceived);

});

const onComplianceBarDisplayDataReceived = (size)=> { // top bar height in pixes (20/40 depending on the jurisdiction)
    PSState.updateGameInnerCanvasSize({
        top: {
            compliance: size
        }
    });
 };
